function splitTextToSpans(element) {
  const text = element.textContent.trim()
  element.innerHTML = ''

  const offsetIncrement = 0.01
  const spanClasses =
    'inline-block relative [text-shadow:0px_1.3em_currentColor] translate-y-0 transition-transform duration-600 ease-custom-ease group-hover:-translate-y-4'

  ;[...text].forEach((char, index) => {
    const span = document.createElement('span')
    span.textContent = char
    span.style.transitionDelay = `${index * offsetIncrement}s`
    span.className = spanClasses

    if (char === ' ') {
      span.style.whiteSpace = 'pre'
    }

    element.appendChild(span)
  })
}

function initButtonCharacterStagger() {
  const elements = document.querySelectorAll('[data-button-animate-chars]')

  elements.forEach((element) => {
    // Initial split
    splitTextToSpans(element)

    // Observer for text updates (e.g. from variant changes)
    const observer = new MutationObserver((mutations) => {
      let shouldReSplit = false
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          // If the element content was replaced by a single text node
          if (
            element.childNodes.length === 1 &&
            element.childNodes[0].nodeType === Node.TEXT_NODE
          ) {
            shouldReSplit = true
          }
        }
      })

      if (shouldReSplit) {
        splitTextToSpans(element)
      }
    })

    observer.observe(element, { childList: true })
  })
}

document.addEventListener('DOMContentLoaded', initButtonCharacterStagger)
